// NOTES
//-------------------------------------------------------------------------------------------------------------------------
//BOOTSTRAP: https://ng-bootstrap.github.io/#/getting-started


// IMPORTS
//-------------------------------------------------------------------------------------------------------------------------
//Angular
import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { RouterModule, Router } from '@angular/router';
import { HttpClientModule } from '@angular/common/http';

//Components
import { NavigationComponent } from './components/navigation';
import { Page404Component } from './components/page404';
import { AppComponent } from './components/app';

//Modules
import { PublicModule } from '../public/public.module';
import { CPDESModule } from '../cpdes/cpdes.module';
import { TestHarnessModule } from '../test-harness/test-harness.module';
import { SharedModule } from '../shared/shared.module';

//Third Party
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';

//Services
//import { AuthGuard } from "../shared/services/authGuard"
import { CASNavBoxService } from '../shared/components/cas-navbox/cas-navbox-service';
//import { FormDataService2 } from '../shared/services/formData2';
import { Helpers } from '../shared/services/helpers';
import { WebServices } from '../shared/services/webServices';

//Globals
import { appConfig } from '../shared/appConfig.js';

//Token
import { authToken } from '../shared/authToken.js';


// LOCALS
//-------------------------------------------------------------------------------------------------------------------------
console.log("=============================================");
console.log("App starting...");
console.log("AppId:", appConfig.X_APP_ID());
console.log("Environment:", appConfig.ENVIRONMENT());
console.log("User:", authToken.user);
console.log("Machine:", appConfig.MACHINE_NAME());
console.log("VERSION:", appConfig.VERSION);

console.log("ALLOW_TEST_HARNESS:", appConfig.ALLOW_TEST_HARNESS);
console.log("DEV_MODE:", appConfig.DEV_MODE);
console.log("ROOT_PATH:", appConfig.ROOT_PATH);
console.log("SHOW_DEBUG_TOOLS:", appConfig.SHOW_DEBUG_TOOLS);
console.log("AuthToken:", authToken);
console.log("eAuth:", appConfig.EAUTH_ENABLED);
console.log("=============================================");

const routes = [
    { path:'', redirectTo:'cpdes', pathMatch:'full' },
    { path:'**', component:Page404Component }
];


// EXPORTS
//-------------------------------------------------------------------------------------------------------------------------
//~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
// AppModule
//~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
@NgModule({
    imports : [

      //Angular
      BrowserModule,
      HttpClientModule,

      //CPD Modules
      CPDESModule,
      PublicModule,
      SharedModule,
      TestHarnessModule,

      //Bootstrap
      NgbModule,

      //Must be last in import order
      RouterModule.forRoot(routes)
    ],
    declarations : [
      NavigationComponent,
      Page404Component,
      AppComponent
    ],

    providers: [
        //Starting to push these to the app as I'm getting tired of adding them to everything else
        CASNavBoxService,
        //FormDataService2,
        Helpers,
        WebServices
    ],
    
    bootstrap : [
      AppComponent
    ]
})
export class AppModule {

    // INITIALIZATION
    //-------------------------------------------------------------------------------------------------------------------------
    //==================================
    // constructor
    //==================================
    constructor(router:Router){
        //console.log("authToken.isUserLoggedIn()", authToken.isUserLoggedIn());
    //    //Check for route changes
    //    router.events.subscribe((event) => { 
    //        console.log("[app.module:routeChanged]", event);
    //        if (event instanceof NavigationStart ){
    //            if (!authToken.isUserLoggedIn()){
    //                this.router.navigate(["/publicView"]);
    //            }
    //        }
            
    //    });
    };
}
